<template>
  <div class="row m-0 justify-content-md-center">
    <h2 class="col-12 mb-0 block-header" data-toggle="collapse" href="#order-form" role="button" aria-expanded="true" aria-controls="order-form">Оставить заявку</h2>
    <div class="col-12 col-lg-8 align-self-center collapse show mt-2" id="order-form">
      <form action="#">
        <div class="form-group row pt-1 pb-1 m-0">
          <label class="col-4 col-md-2 text-right" for="name">ИМЯ *</label>
          <input class="col-8 col-md-10 form-control" id="height" v-model="name" required>
        </div>
        <div class="form-group row pt-1 pb-1 m-0">
          <label class="col-4 col-md-2 text-right" for="email">EMAIL *</label>
          <input class="col-8 col-md-10 form-control" id="email" type="email" v-model="email" required>
        </div>
        <div class="form-group row pt-1 pb-1 m-0">
          <label class="col-4 col-md-2 text-right" for="phone">ТЕЛЕФОН *</label>
          <input class="col-8 col-md-10 form-control" id="phone" v-model="phone" required>
        </div>
        <div class="form-group row pt-1 pb-1 m-0">
          <label class="col-4 col-md-2 text-right" for="count">КОЛИЧЕСТВО</label>
          <input class="col-8 col-md-10 form-control pb-0 pt-0" type="number" id="count" v-model="count" @change="countValidator">
        </div>
        <div class="form-group row pt-1 pb-1 m-0">
          <label class="col-4 col-md-2 text-right" for="comment">ПОЖЕЛАНИЯ</label>
          <textarea class="col-8 col-md-10 form-control" id="comment" rows="3" v-model="comment" placeholder="Назначение (название, марка, модель устройства)"/>
        </div>
        <Uploader class="mt-1 mb-1" ref="pond" :files="files"/>
        <div class="form-group row pt-1 pb-1 m-0">
          <button type="button" class="btn btn-outline-primary w-100" @click="order">Отправить заявку</button>
        </div>
        <div v-if="error.length > 0" class="alert alert-danger mt-1 mb-1" role="alert">{{ error }}</div>
        <div v-if="ok.length > 0" class="alert alert-info mt-1 mb-1" role="alert">{{ ok }}</div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Uploader from './Uploader';
export default {
  name: "Login",
  props: {
    configuration: Object,
  },
  data() {
    return {
      error: '',
      ok: '',
      name: '',
      email: '',
      phone: '',
      count: 1,
      comment: '',
      files: [],
    }
  },
  methods: {
    order() {
      this.error = '';
      this.ok = '';
      if (this.name.trim().length == 0) {
        this.error = "Введите имя для связи";
        return;
      }
      var email_regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
      if (!email_regex.test(this.email)) {
        this.error = "Введите email";
        return;
      }
      if (this.phone.trim().length < 10) {
        this.error = "Введите телефон";
        return;
      }
      var data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        count: this.count,
        comment: this.comment,
        data: this.configuration.data,
        attachments: this.files,
      };
      if (this.configuration.id >= 0) {
        data.configuration = this.configuration.id;
      }
      axios.post('orders', data).then(() => {
        this.name = '';
        this.email = '';
        this.phone = '';
        this.count = 1;
        this.comment = '';
        this.files = [];
        this.$refs.pond.clear();
        this.ok = "Заявка отправлена, в ближайшее время мы с вами свяжемся";
      }).catch((err) => this.error = err.response.data);
    },
    countValidator() {
      if (!(this.count > 0))
        this.count = 1;
    },
  },
  components: {
    Uploader,
  },
}
</script>
